export default {"src":"/_next/static/image/public/img/icons/info-circle-red.97bfb9182c16335162f55cadabb37ac6.svg","height":34,"width":35};